var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrameView',{attrs:{"url":"https://www.tradespoon.com/members/ytltr.php","title":"Live Trading Room Recordings"}})}
var staticRenderFns = []

export { render, staticRenderFns }